// extracted by mini-css-extract-plugin
export default {"card":"BrandCard_card__+MmUS","brand_icon":"BrandCard_brand_icon__3g3y1"};